import { createFileRoute, useParams } from '@tanstack/react-router';
import { ConsultantDetailViewPage } from '@/pages/consultant/consultant-detail-view-page.tsx';

export const Route = createFileRoute('/_auth/berater/$consultantId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { consultantId } = useParams({ from: '/_auth/berater/$consultantId' });
  return <ConsultantDetailViewPage consultantId={consultantId} />;
}
